import { render, staticRenderFns } from "./BwWysiwyg.vue?vue&type=template&id=010eef79&"
import script from "./BwWysiwyg.vue?vue&type=script&lang=js&"
export * from "./BwWysiwyg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports